import { useQuery } from '@tanstack/react-query';
import { QueryConfig, ExtractFnReturnType } from '../../../../lib/react-query';
import i18n from '../../../../i18n';
import { getClaimPersonalRelationshipSelect } from '../api/claimPersonalRelationship';

type QueryFnType = typeof getClaimPersonalRelationshipSelect;

type UseServiceFunctionalAreaOptions = { 
  config?: QueryConfig<QueryFnType>;
};

export const useClaimPersonalRelationshipSelect = ({ config = {} }: UseServiceFunctionalAreaOptions) => {
    return useQuery<ExtractFnReturnType<QueryFnType>>({
        ...config,
        queryKey: ['claimPersonalRelationshipSelect', i18n.language],
        queryFn: () => getClaimPersonalRelationshipSelect(), //
        refetchOnMount: false,
        refetchOnWindowFocus: false,
    });
};